import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {handleHttpResponse} from "../utils/http-helpers";


const initialState = {
    data: [],
    loading: false,
    checkedRulesDict: {},
    initialRuleValue: {},
    msg: "",
}

export const fetchValidationRules = createAsyncThunk(
    "validationRules/getValidationRules",
    async () => {
        return await fetch('/api/rule')
            .then(handleHttpResponse)
    }
)

export const validationRuleSlice = createSlice({
    name: 'validationRules',
    initialState,
    reducers: {
        addCheckedRule: (state, action) => {
            const ruleName = action.payload.selectedRuleName;
            const dependants = action.payload.selectedDependants;
            if (dependants.length) {

                dependants.forEach( dep => {
                    state.checkedRulesDict[dep].push(ruleName);
                })
            }

            state.checkedRulesDict[ruleName] = [];

            // state.data.map(rule => {
            //     if (rule.name === ruleName) {
            //         rule.selected = true;
            //     }
            // })

        },
        removeCheckedRule: (state, action) => {
            const ruleName = action.payload.selectedRuleName;
            const dependants = action.payload.selectedDependants;

            if (dependants.length) {
                Object.entries(state.checkedRulesDict).forEach( ([key, value])  => {
                    if (key !== ruleName && value.length) {
                        state.checkedRulesDict[key] = value.filter( r => r !== ruleName);
                    }
                })

            }

            delete state.checkedRulesDict[ruleName];

            state.data.forEach(rule => {
                if (rule.name === ruleName) {
                    rule.selected = false;
                }
            })
        },
        removeCheckedRuleAndAllDependants : (state, action) => {
            const rulesToBeRemoved = action.payload.selectedRulesName;

            rulesToBeRemoved.forEach( rule => {
                delete state.checkedRulesDict[rule];
            })

            // TODO: Review loop with Yan
            Object.entries(state.checkedRulesDict).forEach( ([key, value]) => {
                rulesToBeRemoved.forEach( rule => {
                    value = value.filter( r => r !== rule);
                    state.checkedRulesDict[key] = value;

                })
            })

            state.data.forEach(rule => {
                rulesToBeRemoved.beforeEach( r => {
                    if (rule.name === r) {
                        rule.selected = false;
                    }
                })
            })

        },
        addLocalToData: (state, action) => {
            const ruleName = action.payload.name;
            const ruleValue = action.payload.value;
            const index = state.data.findIndex(rule => rule.name === ruleName);
            state.data[index] = ruleValue;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchValidationRules.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(fetchValidationRules.fulfilled, (state, action) => {
                const res = action.payload;
                const storage = {}

                state.loading = false;
                state.data = res;

                // TODO: review the loop in the feature
                /**
                 *  - use Object
                 *  - checkedRulesMap => store checked rule and other checked rules that depend on this rule
                 */
                res && res.forEach( rule => {
                    if (rule.selected) {
                        state.checkedRulesDict[rule.name] = [];
                        if (rule.dependsOnAsSet.length) {
                            rule.dependsOnAsSet.forEach( r => {
                                state.checkedRulesDict.hasOwnProperty(r) && state.checkedRulesDict[r].push(rule.name);
                            });
                        }
                    }
                    storage[rule.name] = rule;
                })

                state.initialRuleValue = storage;
            })
            .addCase(fetchValidationRules.rejected, (state, action) => {
                state.msg = "No Validation Rules Found"
                console.error("Unable to fetch rules from database");
            })
    }
})

export const { addCheckedRule, removeCheckedRule, addValueToData, addEccrValue, changeFuzzyRate, changeTolerated, changeSeverity, removeCheckedRuleAndAllDependants, addLocalToData } = validationRuleSlice.actions;

export default validationRuleSlice.reducer;
